<maps-drawer *ngIf="open" label="Saved searches" (closed)="OnClosed()">
    <div drawerTitle class="drawer-heading" data-testid="saved-searches-drawer">
        <h2>Saved searches</h2>
        <p class="sub">Every search is saved automatically. Click one to reopen its results.</p>
    </div>

    <p class="none" role="status" *ngIf="rows.length === 0">
        No saved searches yet — results will appear here after the first search.
    </p>

    <ul class="list" *ngIf="rows.length > 0">
        <li *ngFor="let row of rows; trackBy: TrackByRow">
            <div
                class="row"
                [class.is-editing]="editingId === row.searchId"
                role="button"
                tabindex="0"
                [attr.aria-label]="'Reopen search ' + row.title"
                (click)="RestoreRow(row)"
                (keydown.enter)="RestoreRow(row)">
                <svg class="clock" viewBox="0 0 16 16" aria-hidden="true">
                    <circle cx="8" cy="8" r="6.2" fill="none" stroke="currentColor" stroke-width="1.3" />
                    <path d="M8 4.8V8l2.2 1.6" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
                </svg>
                <div class="detail">
                    <ng-container *ngIf="editingId !== row.searchId; else editBox">
                        <span class="title">{{ row.title }}</span>
                        <span class="meta">
                            <ng-container *ngIf="row.dateText">{{ row.dateText }} · </ng-container>
                            {{ row.resultCount }} {{ row.resultCount === 1 ? 'candidate' : 'candidates' }}
                        </span>
                    </ng-container>
                    <ng-template #editBox>
                        <input
                            class="edit-input"
                            type="text"
                            mapsAutofocus
                            [(ngModel)]="editDraft"
                            maxlength="200"
                            aria-label="Search title"
                            (click)="$event.stopPropagation()"
                            (keydown.enter)="CommitEdit(row); $event.stopPropagation()"
                            (keydown.escape)="CancelEdit(); $event.stopPropagation()"
                            (blur)="CommitEdit(row)" />
                    </ng-template>
                </div>
                <button
                    *ngIf="editingId !== row.searchId"
                    type="button"
                    class="edit-btn"
                    data-testid="edit-title"
                    [attr.aria-label]="'Rename ' + row.title"
                    (click)="StartEdit(row, $event)">
                    <svg viewBox="0 0 16 16" aria-hidden="true">
                        <path d="M9.8 3.2l3 3L6 13H3v-3l6.8-6.8zM11.3 1.7l3 3"
                              fill="none" stroke="currentColor" stroke-width="1.4"
                              stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
        </li>
    </ul>

    <button type="button" class="load-more" *ngIf="hasMore" [disabled]="isLoadingMore" (click)="LoadMore()">
        {{ isLoadingMore ? 'Loading…' : 'Load more' }}
    </button>
</maps-drawer>
